import { PriceAdjustmentDto } from "./PriceAdjustmentDto";
var ProductItemDto = (function () {
    function ProductItemDto(basePrice, id, isBonusProduct, name, price, priceAdjustments, discountedPrice, productId, quantity, shipmentId, variationData, maxQuantity, image) {
        if (basePrice === void 0) { basePrice = 0; }
        if (id === void 0) { id = ''; }
        if (isBonusProduct === void 0) { isBonusProduct = false; }
        if (name === void 0) { name = ''; }
        if (price === void 0) { price = 0; }
        if (priceAdjustments === void 0) { priceAdjustments = []; }
        if (discountedPrice === void 0) { discountedPrice = 0; }
        if (productId === void 0) { productId = ''; }
        if (quantity === void 0) { quantity = 0; }
        if (shipmentId === void 0) { shipmentId = ''; }
        if (variationData === void 0) { variationData = {}; }
        if (maxQuantity === void 0) { maxQuantity = 10; }
        this.basePrice = basePrice;
        this.id = id;
        this.isBonusProduct = isBonusProduct;
        this.name = name;
        this.price = price;
        this.priceAdjustments = priceAdjustments;
        this.discountedPrice = discountedPrice;
        this.productId = productId;
        this.quantity = quantity;
        this.shipmentId = shipmentId;
        this.variationData = variationData;
        this.maxQuantity = maxQuantity;
        this.image = image;
    }
    ProductItemDto.fromOcapi = function (ocapiProductItem) {
        var priceAdjustments = ocapiProductItem.price_adjustments && ocapiProductItem.price_adjustments.map(function (pa) { return PriceAdjustmentDto.fromOcapi(pa); });
        return new ProductItemDto(ocapiProductItem.base_price, ocapiProductItem.item_id, ocapiProductItem.bonus_product_line_item, ocapiProductItem.product_name, ocapiProductItem.price, priceAdjustments, ocapiProductItem.price_after_item_discount, ocapiProductItem.product_id, ocapiProductItem.quantity, ocapiProductItem.shipment_id, ocapiProductItem.c_variantdata, ocapiProductItem.c_maxProductBasketQuantity, ocapiProductItem.c_image);
    };
    return ProductItemDto;
}());
export { ProductItemDto };
//# sourceMappingURL=ProductItemDto.js.map